import { motion } from "framer-motion";
import { ASSETS, waHref } from "@/lib/contact";

export default function Banner() {
  return (
    <section
      data-testid="banner-section"
      className="relative overflow-hidden bg-brand-black py-16 sm:py-24"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <motion.a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="banner-link"
          aria-label="Chamar GORILLAS REBOQUE no WhatsApp"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="group relative block overflow-hidden border border-chrome/25"
        >
          {/* glow */}
          <div
            aria-hidden="true"
            className="absolute inset-x-16 -bottom-10 -z-10 h-40 bg-brand-yellow/20 blur-[110px]"
          />
          <img
            src={ASSETS.banner}
            alt="GORILLAS REBOQUE - Guincho e reboque 24h em Belém. Força, agilidade e confiança. WhatsApp 91 98273-6261."
            className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
            loading="lazy"
            decoding="async"
          />
          {/* frame corners */}
          <span className="pointer-events-none absolute left-4 top-4 h-5 w-5 border-l-2 border-t-2 border-brand-yellow" />
          <span className="pointer-events-none absolute right-4 top-4 h-5 w-5 border-r-2 border-t-2 border-brand-yellow" />
          <span className="pointer-events-none absolute left-4 bottom-4 h-5 w-5 border-l-2 border-b-2 border-brand-yellow" />
          <span className="pointer-events-none absolute right-4 bottom-4 h-5 w-5 border-r-2 border-b-2 border-brand-yellow" />
        </motion.a>
      </div>
    </section>
  );
}
